/** Shared API/editor policy. Byte limits use 1,024-based units. */
export const CMS_IMAGE_LIMITS = Object.freeze({
  maxCount: 100,
  maxBytes: 150 * 1024 * 1024,
  maxUploadBytes: 10 * 1024 * 1024,
  maxStoredBytes: 4 * 1024 * 1024,
  maxPixels: 25_000_000,
});
export const CMS_DOCUMENT_LIMITS = Object.freeze({
  maxCount: 60,
  maxBytes: 100 * 1024 * 1024,
  maxUploadBytes: 15 * 1024 * 1024,
});
export const CMS_PAGE_LIMIT = 30;
export const CMS_SECTION_LIMIT = 40;
export const CMS_MENU_LIMIT = 60;
